import { Redirect, Route, Switch } from "react-router-dom";
import React from "react";
import { ActiveIssues } from "components/ActiveIssues/ActiveIssues";

export const LostEnergyRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/lost-energy/issue-tracking">
        <ActiveIssues />
      </Route>

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect
        to="/pages/lost-energy/issue-tracking"
        from="/pages/lost-energy"
      />
      <Redirect to="/pages" />
    </Switch>
  );
};
